/**
 * A15 — Liasse Fiscale API client
 * Canonical mount: /api/comptabilite/liasse-fiscale
 */
import { apiCall, blobPost } from './api';

const BASE = '/comptabilite/liasse-fiscale';

const buildFiscalYearQuery = (fiscalYearOrOptions) => {
  if (!fiscalYearOrOptions) return '';
  if (typeof fiscalYearOrOptions === 'object') {
    const { fiscal_year_id, fiscal_year } = fiscalYearOrOptions;
    const id = fiscal_year_id ?? fiscal_year;
    return id ? `?fiscal_year_id=${encodeURIComponent(id)}` : '';
  }
  return `?fiscal_year_id=${encodeURIComponent(fiscalYearOrOptions)}`;
};

export const getLiasseFiscale = async (fiscalYearOrOptions = null) => {
  const result = await apiCall(`${BASE}${buildFiscalYearQuery(fiscalYearOrOptions)}`);
  const data = result.data || {};
  if (Array.isArray(data)) {
    return {
      overview: {
        exercice: '2024',
        dateDepot: '',
        statusKey: 'overview_status_preparation',
        completionRate: 0,
      },
      tableaux: [],
      redressements: [],
    };
  }
  return data;
};

export const createLiasseFiscaleItem = async (data) => {
  const now = new Date().toISOString();
  const payload = { ...data, created_at: now, updated_at: now };
  const result = await apiCall(BASE, 'POST', payload);
  return result.data;
};

export const updateLiasseFiscaleItem = async (id, data) => {
  const payload = { ...data, updated_at: new Date().toISOString() };
  const result = await apiCall(`${BASE}/${id}`, 'PUT', payload);
  return result.data;
};

export const saveManualTableau = async (tableauNumber, fiscalYearId, data) => {
  return apiCall(`${BASE}/manual/${tableauNumber}`, 'POST', {
    fiscal_year_id: fiscalYearId,
    data,
  });
};

export const generateLiasseFiscale = async (params) => {
  const result = await apiCall(`${BASE}/generate`, 'POST', params);
  return result.data;
};

export const calculateAllTableaux = async (fiscalYearId, inventoryMethod = 'permanent') => {
  const result = await apiCall(`${BASE}/calculate/all`, 'POST', {
    fiscal_year_id: fiscalYearId,
    inventory_method: inventoryMethod,
  });
  return result.data;
};

export const calculateSpecificTableau = async (tableauNumber, fiscalYearId, options = {}) => {
  const result = await apiCall(`${BASE}/calculate/${tableauNumber}`, 'POST', {
    fiscal_year_id: fiscalYearId,
    ...options,
  });
  return result.data;
};

export const exportLiasse = async (fiscalYearId, format = 'excel', options = {}) => {
  return blobPost(`${BASE}/export`, {
    fiscal_year_id: fiscalYearId,
    format,
    options,
  });
};
